import React, { useEffect, useState } from "react";
import DesktopMenu from "../../common/DesktopMenu/index";
import MobileMenu from "../../common/MobileMenu/index";
import useWindowSize from "../../common/windowSize";
import NewFooter from "../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { privateAPI } from "../../utils/api";
import { 
  Background, 
} from "../../common/Faq/styles";
import { getCookie, removeCookie } from "../../utils/cookie";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import {
  HelloBox,
  UserHeader,
  UserButton,
  ButtonWrapper,
  ImageWrapper,
  ButtonsWrapper,
  UserLabel,
  UserData,
  UserDataWrapper,
  UserDataBigWrapper,
  UserDataHalf,
  DataWrapper
} from './styles';
import PersonIcon from '@mui/icons-material/Person';
import ChartIcon from '../../assets/products/cartWhite.svg';
import NoProfilePic from '../../assets/nonProfileImage.png';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const UserProfile = () => {
  const navigate = useNavigate();
  const size = useWindowSize();
  const [userName] = useState(getCookie('userName'));
  const [userID] = useState(getCookie('userId'));

  const [mobileMenu, setMobileMenu] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);

  const updateImage = async (e) => {
    const file = Array.from(e.target.files)[0];

    const isImage = /(?:jpg|jpeg|gif|png)/.test(file.type);
    if (!isImage) {
        setLoading(false);
        toast.info('File type need to be jpg, gif or png.');
        return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoadingImage(true);
      const imageResponse = await privateAPI.post(
        "/auth/bacchus/client/image/upload",
        formData
      );
      if(imageResponse.data[0]) {
        userInfo.image = imageResponse.data[0]
        await privateAPI.put(
          `/auth/bacchus/client/user/${userID}`,
          userInfo
        );
      } else {
        return toast.info("We run into server problem.");
      }
      setLoadingImage(false);
    } catch (e) {
      setLoadingImage(false);
    }
  };

  const getUserById = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/user/${userID}`);
      setUserInfo(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    removeCookie('token')
    removeCookie('userName')
    removeCookie('isAdmin')
    removeCookie('userId')
    if(window.location.pathname.length === 1) return window.location.reload()
    navigate("/")
  }

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <DataWrapper>
          <HelloBox><h2>Welcome, {userName ? userName : 'dear client'}</h2></HelloBox>
          <UserHeader>
            <ImageWrapper>
              {loadingImage ?
                <Backdrop 
                  sx={{ 
                    color: "#fff",
                    zIndex: 1000,
                    position: "absolute",
                    top: "0",
                    left: "0",
                    height: "100%",
                    width: "100%" }}
                    open={loadingImage}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                :
                <>
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    id="fileInput"
                    onChange={(e) => updateImage(e)}
                  />
                  <label htmlFor="fileInput">
                    <img
                      src={userInfo.image || NoProfilePic}
                      style={{ width: '100%'}}
                      alt="Client logo"
                    />
                  </label>
                </>
              }
            </ImageWrapper>
            <ButtonsWrapper>
              <ButtonWrapper>
                <UserButton onClick={() => navigate("/profile/settings")}>
                  <PersonIcon sx={{ fontSize: "48px" }}/>
                </UserButton>
                <span onClick={() => navigate("/profile/settings")}>Settings</span>
              </ButtonWrapper>
              <ButtonWrapper>
                <UserButton onClick={() => navigate("/profile/cart")}>
                  <img src={ChartIcon} style={{ width: '46px' }} alt="Chart icon"/>
                </UserButton>
                <span onClick={() => navigate("/profile/cart")}>Cart</span>
              </ButtonWrapper>
              <ButtonWrapper>
                <UserButton onClick={() => navigate("/profile/favorites")}>
                  <FavoriteIcon sx={{ fontSize: "46px" }}/>
                </UserButton>
                <span onClick={() => navigate("/profile/favorites")}>Favorites</span>
              </ButtonWrapper>
              <ButtonWrapper>
                <UserButton onClick={() => navigate("/profile/contact-us")}>
                  <MailOutlineIcon sx={{ fontSize: "45px" }}/>
                </UserButton>
                <span onClick={() => navigate("/profile/contact-us")}>Contact us</span>
              </ButtonWrapper>
              <ButtonWrapper>
                <UserButton>
                  <LogoutIcon onClick={logout} sx={{ fontSize: "44px" }}/>
                </UserButton>
                <span>Logout</span>
              </ButtonWrapper>
            </ButtonsWrapper>
          </UserHeader>
          <UserHeader>
            <UserDataBigWrapper>
              <UserDataHalf>
                {userInfo.company &&
                  <UserDataWrapper>
                    <UserLabel>Company Name</UserLabel>
                    <UserData>{userInfo.company || 'n/a'}</UserData>
                  </UserDataWrapper>
                }
                <UserDataWrapper>
                  <UserLabel>Name</UserLabel>
                  <UserData>{userInfo.name || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>Lastname</UserLabel>
                  <UserData>{userInfo.surname || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>E-mail</UserLabel>
                  <UserData>{userInfo.username || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>Phone</UserLabel>
                  <UserData>{userInfo.phone || 'n/a'}</UserData>
                </UserDataWrapper>
              </UserDataHalf>
              <UserDataHalf>
                <UserDataWrapper>
                  <UserLabel>Street</UserLabel>
                  <UserData>{userInfo.address || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>Post code</UserLabel>
                  <UserData>{userInfo.postCode || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>Place</UserLabel>
                  <UserData>{userInfo.place || 'n/a'}</UserData>
                </UserDataWrapper>
                <UserDataWrapper>
                  <UserLabel>User status</UserLabel>
                  <UserData userStatus={userInfo.status}>{userInfo.status === 'READY_FOR_REVIEW' ? 'IN REVIEW' : userInfo.status || 'n/a'}</UserData>
                </UserDataWrapper>
              </UserDataHalf>
            </UserDataBigWrapper>
          </UserHeader>
        </DataWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default UserProfile;
